import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly onlineSubject = new BehaviorSubject<boolean>(navigator.onLine);
  readonly isOnline$: Observable<boolean> = this.onlineSubject.asObservable();

  constructor() {
    merge(fromEvent(window, 'online'), fromEvent(window, 'offline'))
      .subscribe(() => void this.checkNow());
  }

  get currentOnline(): boolean {
    return this.onlineSubject.value;
  }

  async checkNow(): Promise<boolean> {
    const isOnline = navigator.onLine;
    this.onlineSubject.next(isOnline);
    return isOnline;
  }
}
